<template>
  <section class="ctn">
    <header class="header">
      <router-link class="paper-action" to="/maintenances/new"><heim-icon icon="add"></heim-icon><span>{{ $t('new') }}</span></router-link>
    </header>
    <section class="table">
      <heim-table :data="filteredMaintenances" :columns="['id', 'name', 'date', 'title']" cols="11">
        <template slot="colgroup">
          <col class="one">
          <col class="two">
          <col class="three">
          <col class="four">
          <col class="five">
          <col class="six">
          <col class="seven">
          <col class="eight">
          <col class="nine">
        </template>
        <template slot="thead" slot-scope="props">
          <th class="collapse only-mobile"></th>
          <th class="id sortable" @click="props.sortBy('id')">#<heim-icon :icon="props.sortOrders['id'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="sortable main" @click="props.sortBy('name')">{{ $t('customer') }}<heim-icon :icon="props.sortOrders['name'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="sortable main" @click="props.sortBy('title')">{{ $t('title') }}<heim-icon :icon="props.sortOrders['title'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="date tab-noShow sortable" @click="props.sortBy('date_start')">{{ $t('startDate') }} <heim-icon :icon="props.sortOrders['startDate'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="date tab-noShow sortable" @click="props.sortBy('date_end')">{{ $t('endDate') }} <heim-icon :icon="props.sortOrders['endDate'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="maintenance tab-noShow">{{ $t('amountTotal') }}</th>
          <th class="maintenance tab-noShow">{{ $t('numberDay') }}</th>
          <th class="action edit"></th>
          <th class="action activity"></th>
          <th class="action details"></th>
        </template>
        <template slot="tbody" slot-scope="{ item, index, show, openDetail, cols }">
          <tr :key="'maintenances-'+index">
            <td class="only-mobile">
							<heim-icon-button
								:class="show(item)?'opened':''"
								class="icon-button"
								@click.native="openDetail(item)">
								<heim-icon icon="chevron-right"></heim-icon>
							</heim-icon-button>
						</td>	
            <td class="id" data-title="#">{{item.id}}</td>
            <td data-title="Name">
                <span class="label">{{item.name}}</span>
            </td>
            <td data-title="Name">
                <span>{{item.title ? item.title : $t("na")}}</span>
            </td>
            <td class="tab-noShow" data-title="Date Start">
                <span v-if="item.date_start">{{ $d(new Date(item.date_start), 'short') }}</span>
                <span v-else>{{$t("na")}}</span>
            </td>
            <td class="tab-noShow" data-title="Date End">
                <span v-if="item.date_end">{{ $d(new Date(item.date_end), 'short') }}</span>
                <span v-else>{{$t("na")}}</span>
            </td>
            <td class="maintenance tab-noShow" data-title="Amount">
              <span>{{ item.amount ? $n(item.amount, "currency") : $t('na') }}</span>
            </td>
            <td class="maintenance tab-noShow" data-title="Number of days">
              <span>{{item.days ? item.days : $t("na") }}</span>
            </td>
            <td class="edit" data-title="Edit">
              <router-link class="paper-action" :to="{ path: `/maintenances/${item.id}/edit` }">
                <span>{{ $t('edit') }}</span><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
            </td>
            <td class="activity" data-title="Activity">
              <router-link class="paper-action" :to="{ path: `/maintenances/${item.id}/details` }">
                <heim-icon icon="timeline"></heim-icon><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
            </td>
            <td class="details mobile-link"><router-link class="link" :to="{ path: `/maintenances/${item.id}/details`}"><heim-icon icon="chevron-right"></heim-icon></router-link></td>
          </tr>
          <transition name="slide-fade" :key="'detail-'+index">
						<tr v-if="show(item)" class="detail only-mobile" :data-detail="item.id">
							<td class="detail-row" :colspan="cols">
								<div class="detail-container">
									<div class="row">
										<div class="item">
											<span class="label">{{ $t('startDate') }}</span>
											<div>
                        <span v-if="item.date_start">{{ $d(new Date(item.date_start), 'short') }}</span>
                        <span v-else>{{$t("na")}}</span>
                      </div>
										</div>
                    <div class="item">
											<span class="label">{{ $t('endDate') }}</span>
											<div>
                        <span v-if="item.date_end">{{$d(new Date(item.date_end), 'short') }}</span>
                        <span v-else>{{$t("na")}}</span>
                      </div>
										</div>
										<div class="item">
											<span class="label">{{ $t('amountTotal') }}</span>
											<div>{{item.amount ? item.amount + " €" : $t("na")}}</div>
										</div>
										<div class="item">
											<span class="label">{{ $t('numberDay') }}</span>
											<div>{{item.days ? item.days : $t("na") }}</div>
										</div>
									</div>
								</div>
							</td>
						</tr>
					</transition>
        </template>
      </heim-table>
    </section>
  </section>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon.vue";
import HeimIconButton from "@/components/form/button/heim-icon-button.vue";
import HeimTable from "@/components/layout/list/heim-table.vue";
import { mapState } from "vuex";
import fuseMixin from "@/mixins/fuse";
import { dateFilter } from "vue-date-fns";

export default {
  name: "MaintenanceList",
  components: {
    HeimIcon,
    HeimIconButton,
    HeimTable
  },
  mixins: [fuseMixin],
  mounted() {
    this.$store.dispatch("getMaintenances");
    // we need to setup fuse inside a watcher
    // because otherwise fuse setups itselfs
    // with an empty array (no data has arrived yet)
    this.$watch(
      vm => vm.maintenances,
      val => {
        this.setupMaintenances();
      }
    );
    this.setupMaintenances();

    this.$store.dispatch("setTitle", "Maintenances");
  },
  computed: {
    ...mapState(["search"]),
    ...mapState({ maintenances: state => state.maintenancesState.maintenances })
  },
  methods : {
    getTotal(items) {
      const cost = [];
      items.map(item => {
        cost.push(item.amount);
      });

      return cost.reduce((a, b) => a + b, 0);
    }
  },
  filters: {
    date: dateFilter
  }
};
</script>

<style scoped>
.disabled {
  color: #8b969c;
}

col.one { width: 5%; }
col.two { width: 15%; }
col.three { width: 15%; }
col.four { width: 9%; }
col.five { width: 9%; }
col.six { width: 1%; }
col.seven { width: 3%; }
col.eight { width: 1%; }
col.nine { width: 1%; }
col.ten { width: 1%; }

@media screen and (max-width: 1024px) {
  .tab-noShow {
    display: none;
  }
}
</style>
